import { render, staticRenderFns } from "./survey-step-lipoprotein-a-test.vue?vue&type=template&id=a9c5ee7e"
import script from "./survey-step-lipoprotein-a-test.vue?vue&type=script&lang=js"
export * from "./survey-step-lipoprotein-a-test.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports